// ModalContext.jsx
import React, { createContext, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createPortal } from 'react-dom';
import SignInModal from './components/SigninModal';
import { useAuth } from './AuthContext';

interface SignInModalContextType {
    openSignInModal: (path?: string) => void;
}

const SignInModalContext = createContext<SignInModalContextType | undefined>(undefined);

export function useSignInModal() {
    const context = useContext(SignInModalContext);
    if (context === undefined) {
      throw new Error('useModal must be used within a ModalProvider');
    }
    return context;
  }
  

export function SignInModalProvider({ children }: { children: React.ReactNode }) {
    const [showModal, setShowModal] = useState(false);
    const [redirectPath, setRedirectPath] = useState(undefined);
    const navigate = useNavigate();
    const { token } = useAuth();

    const openSignInModal = (path?: string) => {
        if (token) {
            // If user is already logged in, navigate directly to the path
            if (path) {
                navigate(path);
            }
        } else {
            // Otherwise show the sign-in modal
            setRedirectPath(path);
            setShowModal(true);
        }
    };

    const closeModal = () => {
        setShowModal(false);
        setRedirectPath(undefined);
    };

    return (
        <SignInModalContext.Provider value={{ openSignInModal }}>
            {children}
            {showModal && createPortal(
                <SignInModal onClose={closeModal} redirectPath={redirectPath} />,
                document.body
            )}
        </SignInModalContext.Provider>
    );
}